
export function Confirmation({ year }: { year: number }) {

    return <>

        <p>
            This will enable the new version of the Nutrition module from year {year}, copying all current requirements and plans in the process.
        </p>

        <p>
            Please note that:
            <ul style={{ listStyleType: "disc", padding: "0 3rem" }}>
                <li>The operation is irreversible.</li>
                <li>Omnia will be restarted to take the changes into account.</li>
                <li>The copy will happen in the background, so that all requirements and plans will not be available immediately.</li>
            </ul>
        </p>


    </>
}